import { render, staticRenderFns } from "./accountingSystem.vue?vue&type=template&id=2ba2980a&scoped=true&"
import script from "./accountingSystem.vue?vue&type=script&lang=js&"
export * from "./accountingSystem.vue?vue&type=script&lang=js&"
import style0 from "./accountingSystem.vue?vue&type=style&index=0&id=2ba2980a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba2980a",
  null
  
)

export default component.exports